<template>
  <div>
    <div class="overlay"></div>
    <section id="mop-popup" class="slideDown">
      <div class="title">
        {{ $t('admin.mop.cancel.title') }}
      </div>

      <div class="col">
        <span class="label">{{ $t('admin.mop.cancel.reason') }}</span>
        <textarea class="value" type="text" v-model="value"></textarea>
        <span class="description"
          >{{ $t('admin.mop.cancel.description') }}</span
        >
      </div>

      <div v-if="errors" class="errors">{{ errors }}</div>

      <div class="buttons">
        <div class="button cancel" @click="cancel()">
          {{ $t('general.cancel') }}
        </div>
        <div class="button confirm" @click="validate()">
          {{ $t('admin.mop.cancel.confirm') }}
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import i18n from '@/i18n'
export default {
  props: { mop: Object },
  data() {
    return {
      start_date: false,
      end_date: false,
      value: "",
      errors: false
    };
  },
  created() {},
  computed: {},
  methods: {
    cancel() {
      this.$emit("cancel");
    },
    validate() {
      this.errors = false;

      if (!this.errors && this.value.trim().length < 20) {
        this.errors = i18n.t('admin.mop.cancel.error');
      }

      if (!this.errors) {
        console.warn(this.value);
        this.$emit("confirm", this.value);
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.overlay {
  position: fixed;
  z-index: 10;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.7);
  transition: opacity 500ms;
  background-color: rgba(255, 187, 12, 0.81);
}
#mop-popup {
  background-color: #fff;
  position: fixed;
  width: 700px;
  height: 350px;
  left: calc(50% - 350px);
  top: calc(50% - 175px);
  border-radius: 4px;
  z-index: 20;
  padding: 20px;

  .title {
    margin-bottom: 25px;
  }

  .col {
    width: 500px;
    margin: 0 auto;
    margin-bottom: 10px;
    .label {
      width: 100%;
      display: block;
      text-align: left;
    }
    .description {
      width: 100%;
      display: block;
      text-align: left;
      font-size: 85%;
      color: #666;
    }
    input,
    textarea {
      border: 1px solid #ccc;
      padding: 8px;
      border-radius: 4px;
      width: 100%;
    }
  }
  .errors {
    color: #d42525;
    border: 2px solid #d42525;
    background-color: transparent;
    padding: 8px;
    border-radius: 4px;
    width: 500px;
    margin: 20px auto;
  }

  .buttons {
    width: 500px;
    display: flex;
    margin: 0 auto;
    flex-wrap: nowrap;
    align-content: space-around;
    justify-content: center;
    align-items: center;
    flex-direction: row;
    gap: 10px;

    .button {
      display: inline-block;
      cursor: pointer;
      padding: 8px;
      border-radius: 4px;
      background-color: #ccc;
      width: 100%;

      &.confirm {
        background-color: var(--main_color);
      }
    }
  }
}
</style>
